<template>
<!-- 会员管理 - 会员信息详情 - 储值余额消费记录 -->
    <content-view>
        <div class="wrap-container-in">
            <a-table bordered :dataSource="dataSource" :columns="columns" @change="changePage" :pagination="pagination" :rowKey="record => record.id">
                <span slot="businessId" slot-scope="businessId">{{businessId ? businessId : "-"}}</span>
                <!-- <span slot="orderTypeName" slot-scope="orderTypeName">{{orderTypeName ? orderTypeName : "-"}}</span> -->
                <span slot="orderTime" slot-scope="orderTime">{{orderTime ? orderTime : "-"}}</span>
                <span slot="operator" slot-scope="operator">{{operator ? operator : "-"}}</span>
                <span slot="operatingTime" slot-scope="operatingTime">{{operatingTime ? operatingTime : "-"}}</span>
                <span slot="financeType" slot-scope="financeType">{{['减储值', "", '加储值',][financeType + 1] || "-"}}</span>
            </a-table>
            <div class="text-center mt16">
                <a-button @click="$router.go(-1)" >返回</a-button>
            </div>
        </div>
    </content-view>
</template>

<script type="text/javascript">
    const columns = [
    {
        title: "订单号",
        dataIndex: "businessId",
        scopedSlots: { customRender: "businessId" }
    },
    // {
    //     title: "订单类型",
    //     dataIndex: "orderTypeName",
    //     scopedSlots: { customRender: "orderTypeName" }
    // },
    // {
    //     title: "订单时间",
    //     dataIndex: "businessTime",
    //     scopedSlots: { customRender: "businessTime" }
    // },
    {
        title: "金额/元",
        dataIndex: "changeValue"
    },
    {
        title: "类型",
        dataIndex: "financeType",
        scopedSlots: {customRender: 'financeType'}
    },
    {
        title: "来源",
        dataIndex: "description",
    },
    // {
    //     title: "操作人",
    //     dataIndex: "operator",
    //     scopedSlots: { customRender: "operator" }
    // },
    {
        title: "变更时间",
        dataIndex: "businessTime",
        scopedSlots: { customRender: "businessTime" }
    },]
    export default {
        name: "storedVlaueUseRecored",
        zn: '储值余额消费记录',
        components: {},
        props: {},
        data() {
            return {
                columns,
                dataSource: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
            };
        },
        computed: {},
        methods: {
            changePage(page) {
                this.pagination.pageSize = page.pageSize
                this.pagination.current = page.current
                this.getList()
            },
            // 获取会员积分详情
            getList() {
                this.$api.member.getStoredValueConsume({
                    body: {
                            userId: this.$route.params.id,
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize
                        }
                }).then(res => {
                    this.pagination.total = res.total;
                    this.dataSource = res.list
                })
            },
        },
        created() {},
        mounted() {
            this.getList()
        }
    };
</script>
<style lang="scss">
</style>